/**
 * 届次状态枚举
 *
 * 状态流转：
 * PREPARING → PUBLISHED → IN_PROGRESS → ENDED → ARCHIVED
 */
export enum EditionStatus {
  /** 筹备中 - 届次信息录入中，尚未发布 */
  PREPARING = 'PREPARING',
  /** 已发布 - 已发布到嘉宾端，邀约码生效 */
  PUBLISHED = 'PUBLISHED',
  /** 进行中 - 届次正在进行 */
  IN_PROGRESS = 'IN_PROGRESS',
  /** 已结束 - 届次已结束，邀约码自动失效 */
  ENDED = 'ENDED',
  /** 已归档 - 数据归档完成 */
  ARCHIVED = 'ARCHIVED',
}

/** 所有状态值的数组 */
export const EditionStatusValues: string[] = Object.values(EditionStatus);

/** 状态中文标签映射 */
export const EditionStatusLabels: Record<EditionStatus, string> = {
  [EditionStatus.PREPARING]: '筹备中',
  [EditionStatus.PUBLISHED]: '已发布',
  [EditionStatus.IN_PROGRESS]: '进行中',
  [EditionStatus.ENDED]: '已结束',
  [EditionStatus.ARCHIVED]: '已归档',
};

/** 合法的状态流转映射 */
export const EditionStatusTransitions: Record<EditionStatus, EditionStatus[]> = {
  [EditionStatus.PREPARING]: [EditionStatus.PUBLISHED],
  [EditionStatus.PUBLISHED]: [EditionStatus.IN_PROGRESS],
  [EditionStatus.IN_PROGRESS]: [EditionStatus.ENDED],
  [EditionStatus.ENDED]: [EditionStatus.ARCHIVED],
  [EditionStatus.ARCHIVED]: [],
};
